import React from 'react';
import { ExplorationChat } from './ExplorationChat';

export const ExplorationPage: React.FC = () => {
  return <ExplorationChat />;
};
